var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 149.7 192.4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75.5 192.4h74.2V74.9l-20-20.1L75.6.8l-.8-.8L20 54.9l-20 20v117.4h7.1V77.8l.3-.3 66.8-66.8.7-.7.7.7 66.8 66.8.3.3V186H75.5C60.9 186 49 174.1 49 159.4s11.9-26.6 26.6-26.6h20.7v6.4l16.7-9.6-16.8-9.6v6.4H75.5c-18.2.9-32.2 16.4-31.3 34.6.8 17 14.4 30.5 31.3 31.4",
  className: "logo_svg__st0"
})));
export default SvgLogo;